import {
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { RevenueText } from "@root/components/adminDashboard/components";
import { CustomText } from "@root/components/common/components";
import NoRecordsText from "@root/components/common/text/noRecordsText";
import {
  ColumnFlex,
  StyledAvatar,
} from "@root/components/dashboard/chat/style";
import { StyledUserTag } from "@root/components/dashboard/sidebar/style";
import { dateConverter } from "@root/utils/dateHelper";
import { StatusViewer } from "../components";
import { AdminPagination } from "../pagination";
import { WEB_TABLES_MAX_LIMIT } from "@root/webConstants";
import { useTranslation } from "react-i18next";
import { getIsAdminByRoleId } from "@root/utils/helpers";
import { Paginate } from "@root/components/pagination";
import { PAGINATION_DEFAULTS } from "@root/constants";

export const UserManageMainTable = ({
  tableHeaders,
  tableItems,
  onViewDetails,
  onPageChange,
  setCurrentPage,
  currentPage,
  count,
}: any) => {
  const { t } = useTranslation("common");

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    onPageChange(pageNumber);
  };

  if (
    (tableItems?.rows && tableItems?.rows?.length === 0) ||
    !tableItems?.rows
  ) {
    return <NoRecordsText />;
  }

  return (
    <ColumnFlex gap={"24px"}>
      <TableContainer
        border={"1px solid"}
        borderColor={"gray.100"}
        borderRadius={"16px"}
        marginLeft={"15px"}
      >
        <Table variant="simple">
          <Thead h={"62px"} bgColor={"gray.100"}>
            <Tr>
              {tableHeaders.map((item: string, key: number) => (
                <Th key={key} textTransform={"capitalize"}>
                  <CustomText text={item} fontSize={"16px"} fontWeight={500} />
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {tableItems?.rows?.map((item: any, key: number) => {
              return (
                <Tr
                  key={key}
                  _hover={{
                    bgColor: "theme.bg.couponBox",
                  }}
                  maxH={"56px"}
                >
                  <Td
                    maxHeight={"56px"}
                    borderBottom={"1px solid"}
                    borderColor={"gray.border"}
                  >
                    <CustomText text={item?.id} fontSize={"16px"} />
                  </Td>
                  <Td
                    maxH={"56px"}
                    borderBottom={"1px solid"}
                    borderColor={"gray.border"}
                  >
                    <Flex whiteSpace={"pre"} alignItems={"center"} gap={"12px"}>
                      <StyledAvatar src={item?.avatar} name={item?.fullname} />
                      <CustomText
                        text={item?.fullname}
                        maxW={"150px"}
                        isEllipse
                        fontSize={"16px"}
                      />
                      {getIsAdminByRoleId(item?.roleId || 0) && (
                        <RevenueText
                          fontWeight={500}
                          fontSize="10px"
                          hideArrow
                          text={t("mainTable.admin")}
                        />
                      )}
                    </Flex>
                  </Td>
                  <Td
                    maxH={"56px"}
                    borderBottom={"1px solid"}
                    borderColor={"gray.border"}
                  >
                    <CustomText text={item?.email} fontSize={"16px"} />
                  </Td>
                  <Td
                    maxH={"56px"}
                    borderBottom={"1px solid"}
                    borderColor={"gray.border"}
                  >
                    <CustomText
                      text={dateConverter(
                        item?.last_login,
                        "YYYY/MM/DD HH:MM AM/PM"
                      )}
                      fontSize={"16px"}
                    />
                  </Td>
                  <Td
                    maxH={"56px"}
                    borderBottom={"1px solid"}
                    borderColor={"gray.border"}
                  >
                    <StatusViewer status={item?.is_active} />
                  </Td>

                  <Td
                    maxH={"56px"}
                    borderBottom={"1px solid"}
                    borderColor={"gray.border"}
                  >
                    <CustomText
                      onClick={() => onViewDetails(item)}
                      text={t("mainTable.seeDetail")}
                      fontSize={"12px"}
                      type="primary"
                      fontWeight={700}
                      cursor={"pointer"}
                      userSelect={"none"}
                      width={"fit-content"}
                    />
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>

      <Flex
        justifyContent="center" // center horizontally
        alignItems="center" // center vertically (for children)
        mt="16px" // spacing from table
        mb="20px"
        mx="auto"
      >
        <Paginate
          page={currentPage}
          count={count}
          pageSize={PAGINATION_DEFAULTS.PAGESIZE}
          onPageChange={handlePageChange}
        />
      </Flex>
    </ColumnFlex>
  );
};
